import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Space, Spin } from "antd";
import {
  MessageChatSquareIcon1,
  MessageChatSquareIcon2,
  MessageChatSquareIcon3,
  MessageChatSquareIcon4,
  MessageChatSquareIcon5,
  MessageChatSquareIcon6,
  SendFillIcon,
  UsersFillIcon,
} from "assets/icons/index";
import moment from "moment";
import { doGetChannelPage } from "stores/slices/channel";
import { dailyMessage } from "stores/slices/dailyMessage";
import {
  doGetDashboard,
  doGetDashboardStatistic,
} from "stores/slices/dashboard";
import {
  getIsRefreshDashboard,
  setHeaderTitle,
  setIsRefreshDashboard,
} from "stores/slices/layout";

import MessageOfTheDay from "components/MessageOfTheDay";
import AppTable from "components/table";

import {
  CHANNEL_NAME,
  CHANNEL_STATUS,
  USER_TYPE,
} from "../../../constants/appConstant";
import { AuthInfo, doGetCreditBalance } from "../../../stores/slices/auth";

// import AreaChart from "./areaChart";
// import DonutChart from "./donutChart";
import MultilineChart from "./multilineChart";
// import StackedColumnChart from "./stackedColumnChart";
import WelcomePage from "./welcomePage";

import styles from "pages/styles.module.scss";

const initialValue = {
  messagesBroadcastInTheLast1Hours: 0,
  messagesBroadcastInTheLast24Hours: 0,
  messagesInboundTheLast1Hours: 0,
  messagesInboundTheLast24Hours: 0,
  messagesRepliesInTheLast1Hours: 0,
  messagesRepliesInTheLast24Hours: 0,
  messagesWaitingForReplies: 0,
  operatorsLoggedIn: 0,
};

const DashboardPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // const firstVisitPageRef = useRef(true);

  const isRefresh = useSelector(state => state.layout.isRefresh);
  const authInfo = useSelector(AuthInfo);
  const messageOfTheDay = useSelector(dailyMessage);
  const isRefreshDashboard = useSelector(getIsRefreshDashboard);

  // const [areaFilterType, setAreaFilterType] = useState("month");
  // const [stackedColumnFilterType, setStackedColumnFilterType] =
  //   useState("month");
  // const [multilineFilterType, setMultilineFilterType] = useState("month");
  // const [donutFilterType, setDonutFilterType] = useState("month");
  const [data, setData] = useState({ ...initialValue });
  const [isLoading, setIsLoading] = useState(false);
  const [dataStatistic, setDataStatistic] = useState([]);
  const [isVisbleModal, setisVisbleModal] = useState(false);
  const [inputText, setInputText] = useState("");
  const [isUpdateDailyMessage, setIsUpdateDailyMessage] = useState(false);
  // const [dataChannels, setDataChannels] = useState([]);
  const [columns, setColumns] = useState([]);
  const [searchParam, setSearchParam] = useState({
    pageNumber: 1,
    pageSize: 10,
    channelStatuses: [CHANNEL_STATUS.ENABLED],
    sortDirection: "DESC",
    sortFieldChannel: "createdTime",
  });

  useEffect(() => {
    dispatch(setHeaderTitle("dashboard"));
  }, []);

  useEffect(() => {
    if (authInfo && authInfo?.type) {
      generateTableColumns();
      handleGetData();
      handleGetDataStatistic();
    }
  }, [authInfo]);

  useEffect(() => {
    handleGetData();
    handleGetDataStatistic();
  }, [isRefresh]);

  // const handleGetServiceAndCreditBalance = async () => {
  //   const params = {
  //     sortField: ["createdTime"],
  //     sortDirection: "DESC",
  //     pageNumber: 1,
  //     pageSize: 10,
  //     workspaceId: authInfo && authInfo.workspaceId,
  //     statuses: ["ASSIGNED"],
  //   };
  //   const { payload } = await dispatch(doGetAddressPage(params));
  //   if (payload?.content?.length > 0) {
  //     const serviceList = payload?.content;
  //     let newListServiceList = serviceList.map(async service => {
  //       if (service?.channel?.apiKey) {
  //         const { payload } = await dispatch(
  //           doGetCreditBalance({ apiKey: service?.channel?.apiKey })
  //         );
  //         return {
  //           ...service,
  //           creditBalance: payload?.data ? payload?.data : null,
  //         };
  //       }
  //     });

  //     newListServiceList = await Promise.all(newListServiceList);
  //     console.log("====================================");
  //     console.log("newListServiceList", newListServiceList);
  //     console.log("====================================");
  //     setDataServices(newListServiceList);
  //   }
  // };

  const handleGetChannelPageAndCreditBalance = async () => {
    if (authInfo && authInfo.type !== USER_TYPE.SUPER_ADMIN) {
      const { payload } = await dispatch(doGetChannelPage(searchParam));
      if (payload?.content?.length > 0) {
        const list = payload?.content;
        let newList = list.map(async channel => {
          const { payload } = await dispatch(
            doGetCreditBalance({ apiKey: channel && channel.apiKey })
          );
          if (payload && payload.status === 200) {
            return {
              ...channel,
              creditBalance: payload && payload.data,
            };
          }
        });
        newList = await Promise.all(newList);
        return { ...payload, content: newList };
      }
    }
  };

  // const capitalizeFirstLetterOfEachWord = text => {
  //   if (text && text.length > 0) {
  //     return text
  //       .split(" ") // Split string into array of words
  //       .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter and convert the remaining letters to lowercase
  //       .join(" "); // Reassemble words into strings
  //   }
  // };

  const generateTableColumns = () => {
    let cols = [
      {
        title: t("dashboard.channel"),
        width: 60,
        dataIndex: "channel",
        key: "channel",
        ellipsis: {
          showTitle: false,
        },
        render: (_, { name }) => (
          <>{name === CHANNEL_NAME.BULKSMS ? t("channelName.BULKSMS") : name}</>
        ),
      },
      {
        title: t("dashboard.creditBalance"),
        width: 60,
        dataIndex: "creditBalance",
        key: "creditBalance",
        ellipsis: {
          showTitle: false,
        },
        render: (_, { creditBalance }) => (
          <>{creditBalance ? creditBalance : "-"}</>
        ),
      },
    ];
    setColumns(cols);
  };

  const handleOpenMessageOfTheDayModal = () => {
    if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
      setIsUpdateDailyMessage(false);
      setInputText("");
      setisVisbleModal(true);
    }
  };

  const handleGetData = async () => {
    setIsLoading(true);
    const { payload } = await dispatch(doGetDashboard());
    if (payload) {
      if (typeof payload === "object") {
        setData({ ...payload });
      } else {
        setData(initialValue);
      }
    } else {
      setData(initialValue);
    }
    setIsLoading(false);
  };
  const convertNumberToStringMonth = (month, dayOfMonth, hour) => {
    switch (month) {
      case 0:
        return `Jan ${dayOfMonth}, ${hour}:00`;
      case 1:
        return `Feb ${dayOfMonth}, ${hour}:00`;
      case 2:
        return `Mar ${dayOfMonth}, ${hour}:00`;
      case 3:
        return `Apr ${dayOfMonth}, ${hour}:00`;
      case 4:
        return `May ${dayOfMonth}, ${hour}:00`;
      case 5:
        return `Jun ${dayOfMonth}, ${hour}:00`;
      case 6:
        return `July ${dayOfMonth}, ${hour}:00`;
      case 7:
        return `Aug ${dayOfMonth}, ${hour}:00`;
      case 8:
        return `Sep ${dayOfMonth}, ${hour}:00`;
      case 9:
        return `Oct ${dayOfMonth}, ${hour}:00`;
      case 10:
        return `Nov ${dayOfMonth}, ${hour}:00`;
      case 11:
        return `Dec ${dayOfMonth}, ${hour}:00`;
    }
  };
  const handleGetDataStatistic = async () => {
    setIsLoading(true);
    const { payload } = await dispatch(doGetDashboardStatistic());
    if (payload && payload.length > 0) {
      const date = new Date();
      const now = moment(date);
      const yesterday = moment(date.setDate(date.getDate() - 1));

      const convertData = payload.map(item => {
        return {
          dayOfMonth: moment(item?.dateTime).date(),
          hour: moment(item?.dateTime).hours(),
          in: item?.numberMessageIn,
          out: item?.numberMessageOut,
          text: convertNumberToStringMonth(
            moment(item?.dateTime).month(),
            moment(item?.dateTime).date(),
            moment(item?.dateTime).hours()
          ),
        };
      });

      let listYesterday = convertData.filter(
        item => item?.dayOfMonth === yesterday.date() && item
      );
      for (let i = yesterday.hour(); i < 24; i++) {
        const isExist = listYesterday.find(item => item?.hour === i);
        if (!isExist) {
          listYesterday.push({
            dayOfMonth: yesterday.date(),
            hour: i,
            in: 0,
            out: 0,
            text: convertNumberToStringMonth(
              yesterday.month(),
              yesterday.date(),
              i
            ),
          });
        }
      }
      const newListYesterday = listYesterday.filter(
        item => item?.hour >= yesterday.hours() && item
      );

      newListYesterday.sort(function (a, b) {
        if (a?.hour < b?.hour) return -1;
        if (a?.hour > b?.hour) return 1;
      });

      // console.log("newListYesterday", newListYesterday);

      let listToday = convertData.filter(
        item => item?.dayOfMonth === now.date() && item
      );
      for (let i = 0; i <= now.hour(); i++) {
        const isExist = listToday.find(item => item?.hour === i);
        if (!isExist) {
          listToday.push({
            dayOfMonth: now.date(),
            hour: i,
            in: 0,
            out: 0,
            text: convertNumberToStringMonth(now.month(), now.date(), i),
          });
        }
      }
      const newListToday = listToday.filter(
        item => item?.hour <= now.hours() && item
      );
      newListToday.sort(function (a, b) {
        if (a?.hour < b?.hour) return -1;
        if (a?.hour > b?.hour) return 1;
      });
      // console.log("newListToday", newListToday);

      let initialStatistic = [...newListYesterday, ...newListToday];

      const statisticIn = initialStatistic.map(item => {
        return {
          type: "Message In",
          hour: item?.text,
          value: item?.in || 0,
          color: "#1F2EB4",
          key: item?.hour,
        };
      });
      const statisticOut = initialStatistic.map(item => {
        return {
          type: "Message Out",
          hour: item?.text,
          value: item?.out || 0,
          color: "#599CE7",
          key: item?.hour,
        };
      });
      let newList = [];
      // initialStatistic = [...statisticIn, ...statisticOut];
      for (let i = 0; i < statisticIn.length; i++) {
        newList = [...newList, statisticIn[i], statisticOut[i]];
      }

      setDataStatistic([...newList]);
      // console.log(
      //   "payload",
      //   payload.map(item => {
      //     console.log("item", moment(item?.dateTime).hours());
      //   })
      // );
    }
  };
  // useEffect(() => {
  //   console.log("isRefresh", isRefresh);
  //   if (isRefresh && isRefresh !== null) {
  //     window.location.reload();
  //   }
  // }, [isRefresh]);

  // const handleFilterChange =  newFilterType => {
  //   setFilterTypes({ ...filterTypes, [chartKey]: newFilterType });
  // };

  // const handleAreaFilterChange = newAreaFilterType => {
  //   setAreaFilterType(newAreaFilterType);
  // };
  // const handleStackedColumnFilterChange = newStackedColumnFilterType => {
  //   setStackedColumnFilterType(newStackedColumnFilterType);
  // };
  // const handleMultilineFilterChange = newMultilineFilterType => {
  //   setMultilineFilterType(newMultilineFilterType);
  // };
  // const handleDonutFilterChange = newFilterType => {
  //   setDonutFilterType(newFilterType);
  // };

  // const renderAreaChartMenu = () => (
  //   <Menu
  //     items={[
  //       {
  //         label: "Day",
  //         onClick: () => handleAreaFilterChange("day"),
  //       },
  //       {
  //         label: "Month",
  //         onClick: () => handleAreaFilterChange("month"),
  //       },
  //       {
  //         label: "Year",
  //         onClick: () => handleAreaFilterChange("year"),
  //       },
  //     ]}
  //   ></Menu>
  // );
  // const renderStackedColumnChartMenu = () => (
  //   <Menu
  //     items={[
  //       {
  //         label: "Day",
  //         onClick: () => handleStackedColumnFilterChange("day"),
  //       },
  //       {
  //         label: "Month",
  //         onClick: () => handleStackedColumnFilterChange("month"),
  //       },
  //       {
  //         label: "Year",
  //         onClick: () => handleStackedColumnFilterChange("year"),
  //       },
  //     ]}
  //   ></Menu>
  // );
  // const renderMultilineChartMenu = () => (
  //   <Menu
  //     items={[
  //       {
  //         label: "Day",
  //         onClick: () => handleMultilineFilterChange("day"),
  //       },
  //       {
  //         label: "Month",
  //         onClick: () => handleMultilineFilterChange("month"),
  //       },
  //       {
  //         label: "Year",
  //         onClick: () => handleMultilineFilterChange("year"),
  //       },
  //     ]}
  //   ></Menu>
  // );
  // const renderDonutChartMenu = () => (
  //   <Menu
  //     items={[
  //       { label: "To day", onClick: () => handleDonutFilterChange("toDay") },
  //       {
  //         label: "This month",
  //         onClick: () => handleDonutFilterChange("thisMonth"),
  //       },
  //       {
  //         label: "This year",
  //         onClick: () => handleDonutFilterChange("thisYear"),
  //       },
  //     ]}
  //   ></Menu>
  // );

  useEffect(() => {
    if (isRefreshDashboard) {
      handleGetData();
      handleGetDataStatistic();
      dispatch(setIsRefreshDashboard(false));
    }
  }, [isRefreshDashboard]);

  return (
    <div className={styles.dashboardPage}>
      {isLoading && (
        <Spin
          size="large"
          style={{
            zIndex: 3,
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "80%",
            height: "85vh",
          }}
        />
      )}
      {authInfo.type === USER_TYPE.USER && authInfo.workspaceId === null ? (
        <>
          <div>
            <WelcomePage />
          </div>
        </>
      ) : (
        <>
          <div
            className={styles.dashboardCards}
            style={{ opacity: isLoading ? 0.5 : 1 }}
          >
            {/* <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={24} style={{ textAlign: "end" }}>
                <Tooltip title={t("button.refresh")}>
                  <Button
                    type="text"
                    onClick={() => {
                      handleGetData();
                      handleGetDataStatistic();
                    }}
                    disabled={isLoading}
                  >
                    <RedoOutlined />
                  </Button>
                </Tooltip>
                {authInfo?.type === USER_TYPE.SUPER_ADMIN &&
                  !messageOfTheDay && (
                    <Button
                      icon={<PlusOutlined />}
                      style={{ marginLeft: 10 }}
                      onClick={handleOpenMessageOfTheDayModal}
                    >
                      {t("button.addMessageOfTheDay")}
                    </Button>
                  )}
              </Col>
              <Col xs={24} sm={12} md={24} style={{ textAlign: "left" }}></Col>
              <Col xs={24} sm={12} md={6}>
                <DashboardCard
                  icon={<UsersFillIcon />}
                  title={t("dashboard.operatorsLoggedIn")}
                  value={data?.operatorsLoggedIn}
                ></DashboardCard>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DashboardCard
                  icon={<SendFillIcon />}
                  title={t("dashboard.messagesWaitingForReplies")}
                  value={data?.messagesWaitingForReplies}
                ></DashboardCard>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DashboardCard
                  icon={<MessageChatSquareIcon2 />}
                  title={t("dashboard.messageInAndOutOverTheLast1Hour")}
                  value={
                    data?.messagesBroadcastInTheLast1Hours +
                    data?.messagesInboundTheLast1Hours
                  }
                ></DashboardCard>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DashboardCard
                  icon={<MessageChatSquareIcon1 />}
                  title={t("dashboard.messageInAndOutOverTheLast24Hours")}
                  value={
                    data?.messagesBroadcastInTheLast24Hours +
                    data?.messagesInboundTheLast24Hours
                  }
                ></DashboardCard>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DashboardCard
                  icon={<MessageChatSquareIcon3 />}
                  title={t("dashboard.messagesInboundTheLast1Hours")}
                  value={data?.messagesInboundTheLast1Hours}
                ></DashboardCard>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DashboardCard
                  icon={<MessageChatSquareIcon4 />}
                  title={t("dashboard.messagesInboundTheLast24Hours")}
                  value={data?.messagesInboundTheLast24Hours}
                ></DashboardCard>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DashboardCard
                  icon={<MessageChatSquareIcon5 />}
                  title={t("dashboard.messagesBroadcastInTheLast1Hours")}
                  value={data?.messagesBroadcastInTheLast1Hours}
                ></DashboardCard>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <DashboardCard
                  icon={<MessageChatSquareIcon6 />}
                  title={t("dashboard.messagesBroadcastInTheLast24Hours")}
                  value={data?.messagesBroadcastInTheLast24Hours}
                ></DashboardCard>
              </Col>
            </Row> */}
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={24} style={{ textAlign: "end" }}>
                {/* <Tooltip title={t("button.refresh")}>
                  <Button
                    type="text"
                    onClick={() => {
                      handleGetData();
                      handleGetDataStatistic();
                    }}
                    disabled={isLoading}
                  >
                    <RedoOutlined />
                  </Button>
                </Tooltip> */}
                {authInfo?.type === USER_TYPE.SUPER_ADMIN &&
                  !messageOfTheDay && (
                    <Button
                      icon={<PlusOutlined />}
                      style={{ marginLeft: 10 }}
                      onClick={handleOpenMessageOfTheDayModal}
                    >
                      {t("button.addMessageOfTheDay")}
                    </Button>
                  )}
              </Col>
              <Col xs={24} sm={12} md={24} style={{ textAlign: "left" }}></Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={12}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12} md={12}>
                    <DashboardCard
                      icon={<UsersFillIcon />}
                      title={t("dashboard.operatorsLoggedIn")}
                      value={data?.operatorsLoggedIn}
                    ></DashboardCard>
                  </Col>
                  <Col xs={24} sm={12} md={12}>
                    <DashboardCard
                      icon={<SendFillIcon />}
                      title={t("dashboard.messagesWaitingForReplies")}
                      value={data?.messagesWaitingForReplies}
                    ></DashboardCard>
                  </Col>
                  <Col xs={24} sm={12} md={12}>
                    <DashboardCard
                      icon={<MessageChatSquareIcon2 />}
                      title={t("dashboard.messageInAndOutOverTheLast1Hour")}
                      value={
                        data?.messagesBroadcastInTheLast1Hours +
                        data?.messagesInboundTheLast1Hours
                      }
                    ></DashboardCard>
                  </Col>
                  <Col xs={24} sm={12} md={12}>
                    <DashboardCard
                      icon={<MessageChatSquareIcon1 />}
                      title={t("dashboard.messageInAndOutOverTheLast24Hours")}
                      value={
                        data?.messagesBroadcastInTheLast24Hours +
                        data?.messagesInboundTheLast24Hours
                      }
                    ></DashboardCard>
                  </Col>
                  <Col xs={24} sm={12} md={12}>
                    <DashboardCard
                      icon={<MessageChatSquareIcon3 />}
                      title={t("dashboard.messagesInboundTheLast1Hours")}
                      value={data?.messagesInboundTheLast1Hours}
                    ></DashboardCard>
                  </Col>
                  <Col xs={24} sm={12} md={12}>
                    <DashboardCard
                      icon={<MessageChatSquareIcon4 />}
                      title={t("dashboard.messagesInboundTheLast24Hours")}
                      value={data?.messagesInboundTheLast24Hours}
                    ></DashboardCard>
                  </Col>
                  <Col xs={24} sm={12} md={12}>
                    <DashboardCard
                      icon={<MessageChatSquareIcon5 />}
                      title={t("dashboard.messagesBroadcastInTheLast1Hours")}
                      value={data?.messagesBroadcastInTheLast1Hours}
                    ></DashboardCard>
                  </Col>
                  <Col xs={24} sm={12} md={12}>
                    <DashboardCard
                      icon={<MessageChatSquareIcon6 />}
                      title={t("dashboard.messagesBroadcastInTheLast24Hours")}
                      value={data?.messagesBroadcastInTheLast24Hours}
                    ></DashboardCard>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={12} md={12}>
                <Row gutter={[16, 16]} className={styles.statisticChart}>
                  {authInfo?.type !== USER_TYPE.SUPER_ADMIN && (
                    <Col xs={24} md={24}>
                      <Card>
                        <div className={styles.chartTitle}>
                          <span
                            style={{
                              fontSize: 24,
                              fontWeight: 600,
                              opacity: 0.8,
                            }}
                          >
                            {t("dashboard.channels")}
                          </span>
                        </div>
                        {columns && (
                          <AppTable
                            searchParam={searchParam}
                            setSearchParam={setSearchParam}
                            columns={columns}
                            scroll={500}
                            border={true}
                            onCustomFetchData={
                              handleGetChannelPageAndCreditBalance
                            }
                          />
                        )}
                      </Card>
                    </Col>
                  )}

                  <Col xs={24} md={24}>
                    <Card>
                      <div className={styles.chartTitle}>
                        <span
                          style={{
                            fontSize: 24,
                            fontWeight: 600,
                            opacity: 0.8,
                          }}
                        >
                          Message statistic in last 24 hours
                        </span>
                        {/* <Dropdown
                      overlay={renderMultilineChartMenu()}
                      trigger={["click"]}
                    >
                      <Button>
                        {multilineFilterType === "year"
                          ? "Year"
                          : multilineFilterType === "month"
                          ? "Month"
                          : "Day"}
                      </Button>
                    </Dropdown> */}
                      </div>
                      <MultilineChart
                        filterType={"hour"}
                        data={dataStatistic}
                        isRefresh={isRefresh}
                      />
                    </Card>
                  </Col>
                  {/* <Col xs={24} md={8}>
                <Card>
                  <div className={styles.chartTitle}>
                    <strong>Best performing brands</strong>
                    <Dropdown
                      overlay={renderDonutChartMenu()}
                      trigger={["click"]}
                    >
                      <Button>
                        {donutFilterType === "thisYear"
                          ? "This year"
                          : donutFilterType === "thisMonth"
                          ? "This month"
                          : "To day"}
                      </Button>
                    </Dropdown>
                  </div>
                  <DonutChart
                    filterType={donutFilterType}
                    isRefresh={isRefresh}
                  />
                </Card>
              </Col> */}
                </Row>
              </Col>
            </Row>
          </div>
          <div style={{ opacity: isLoading ? 0.5 : 1 }}>
            {/* <Row gutter={[16, 16]} className={styles.statisticChart}>
              <Col xs={24} md={12}>
                <Card>
                  <div className={styles.chartTitle}>
                    <strong>Revenue</strong>
                    <Dropdown
                      overlay={renderAreaChartMenu()}
                      trigger={["click"]}
                    >
                      <Button>
                        {areaFilterType === "year"
                          ? "Year"
                          : areaFilterType === "month"
                          ? "Month"
                          : "Day"}
                      </Button>
                    </Dropdown>
                  </div>
                  <AreaChart
                    filterType={areaFilterType}
                    isRefresh={isRefresh}
                  />
                </Card>
              </Col>
              <Col xs={24} md={12}>
                <Card>
                  <div className={styles.chartTitle}>
                    <strong>Total Messages Sent</strong>
                    <Dropdown
                      overlay={renderStackedColumnChartMenu()}
                      trigger={["click"]}
                    >
                      <Button>
                        {stackedColumnFilterType === "year"
                          ? "Year"
                          : stackedColumnFilterType === "month"
                          ? "Month"
                          : "Day"}
                      </Button>
                    </Dropdown>
                  </div>
                  <StackedColumnChart
                    filterType={stackedColumnFilterType}
                    isRefresh={isRefresh}
                  />
                </Card>
              </Col>
            </Row> */}
          </div>
        </>
      )}
      <MessageOfTheDay
        isVisbleModal={isVisbleModal}
        setisVisbleModal={setisVisbleModal}
        inputText={inputText}
        setInputText={setInputText}
        setIsUpdateDailyMessage={setIsUpdateDailyMessage}
        isUpdateDailyMessage={isUpdateDailyMessage}
      />
    </div>
  );

  function DashboardCard({ title, value, icon }) {
    return (
      <Card className={styles.dashboardCard}>
        <Space direction="horizontal">
          {icon}
          <div style={{ marginLeft: 12 }}>
            <p style={{ fontSize: 36, fontWeight: 700, margin: 0 }}>{value}</p>
            <span style={{ fontSize: 14, fontWeight: 500, opacity: 0.8 }}>
              {title}
            </span>
          </div>
          {/* <Statistic
            title={<div className={styles.cardTitle}>{title}</div>}
            value={value}
            valueStyle={{
              fontWeight: "700",
              fontStyle: "normal",
              fontSize: "18px",
              lineHeight: "28px",
            }}
          />
          <Statistic title="Feedback" value={1128} prefix={icon} /> */}
        </Space>
      </Card>
    );
  }
};
export default DashboardPage;
